const PIE_CHART_COLORS = ['#a2d45e', '#37a041', '#006837'];

export { PIE_CHART_COLORS };
